import { createSlice } from "@reduxjs/toolkit";
import { AddAsset, UpdateAsset, GetAssetList, GetAssetDetail } from "services/asset/asset.service";
import { toast } from 'react-toastify';

export const assetAddSlice = createSlice({
  name: "assetAdd",
  initialState: {
    assetAdd: {},
    assetAddLoading: false,
    assetAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddAsset.pending, (state) => {
      // toast.loading('We are adding the asset 🤯')
      state.assetAddLoading = true
    });

    builder.addCase(AddAsset.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New asset added successfully 👌');

      state.assetAdd = action.payload
      state.assetAddLoading = false
      state.assetAddError = null
    });

    builder.addCase(AddAsset.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the asset 😣")

      state.assetAddLoading = false
      state.assetAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const assetUpdateSlice = createSlice({
  name: "assetUpdate",
  initialState: {
    assetUpdate: {},
    assetUpdateLoading: false,
    assetUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateAsset.pending, (state) => {
      // toast.loading('We are updating the asset 🤯')
      state.assetUpdateLoading = true
    });

    builder.addCase(UpdateAsset.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.assetUpdate = action.payload
      state.assetUpdateLoading = false
      state.assetUpdateError = null
    });

    builder.addCase(UpdateAsset.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the asset 😣")

      state.assetUpdateLoading = false
      state.assetUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});


export const assetListSlice = createSlice({
  name: "assetList",
  initialState: {
    assetList: [],
    assetListLoading: false,
    assetListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetAssetList.pending, (state) => {
      state.assetListLoading = true
    });

    builder.addCase(GetAssetList.fulfilled, (state, action) => {
      toast.dismiss();

      state.assetList = action.payload
      state.assetListLoading = false
      state.assetListError = null
    });

    builder.addCase(GetAssetList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the asset 😣")

      state.assetListLoading = false
      state.assetListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const assetDetailSlice = createSlice({
  name: "assetDetail",
  initialState: {
    assetDetail: [],
    assetDetailLoading: false,
    assetDetailError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetAssetDetail.pending, (state) => {
      state.assetDetailLoading = true
    });

    builder.addCase(GetAssetDetail.fulfilled, (state, action) => {
      toast.dismiss();

      state.assetDetail = action.payload
      state.assetDetailLoading = false
      state.assetDetailError = null
    });

    builder.addCase(GetAssetDetail.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the asset detail😣")

      state.assetDetailLoading = false
      state.assetDetailError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});